import { useEffect } from 'react';
import HeapUtils from 'app/utils/heap';
import { useSubscription } from 'app/modules/settings/modules/billing/hooks/useBillingQueries';

/**
 * Keeps the Heap "Pricing plan" property in sync with the authoritative v2
 * subscription. Heap is seeded at app init from the legacy `account.plan.label`,
 * which can carry a stale v1 catalog string (e.g. "Standard (30 users)"); once
 * the v2 `billing/subscription` query resolves we overwrite the plan property
 * with the real `planName`. Mounted once at the private-app root.
 */
const useHeapPlanSync = () => {
  const subscriptionQuery = useSubscription();
  const planName = subscriptionQuery.data?.subscription?.planName ?? '';

  useEffect(() => {
    if (planName) {
      HeapUtils.updatePricingPlan(planName);
    }
  }, [planName]);
};

export default useHeapPlanSync;
